export const equipmentSn = state => state.equipmentSn // 硬件配件列表
export const equipmentArray = state => state.equipmentArray // 硬件配件列表
